$(document).ready(function() {

    //build dropdown
    /*$("<select />").appendTo("#navigation nav");
    
    // Create default option "Go to..."
    $("<option />", {
       "selected": "selected",
       "value"   : "",
       "text"    : "Shop..."
	}).appendTo("nav select");	
	
	// Populate dropdowns with the first menu items
	$("ul#nav li a").each(function() {
	 	var el = $(this);
	 	$("<option />", {
	     	"value"   : el.attr("href"),
	    	"text"    : el.text()
	 	}).appendTo("nav select");
	});
	
	//make responsive dropdown menu actually work			
  	$("nav select").change(function() {
    	window.location = $(this).find("option:selected").val();
  	});*/

	$(".fancybox").fancybox();

  	$('.flexslider').flexslider({
    controlNav: true,
      slideshowSpeed: 6000,
	directionNav: true
  	});
    
	$('.coll-filter').customSelect();
	
   
    $('.product').hover(function(){ $(this).children('#product-info').show(); }, function(){ $(this).children('#product-info').hide(); })
 

	//<![CDATA[
	jQuery(function() {
	  jQuery('#sidebar ul li a').each(function() {
	    if (jQuery(this).attr('href')  ===  window.location.pathname) {
	      jQuery(this).addClass('current');
	    }
	  });
	});  
	//]]>
 

}); 


$(document).ready(function() {
  $(".compact .first").click(function() {
    if($(this).hasClass("active")) {
      $(".mobile-dropdown").hide();
      $(this).removeClass("active");
    } else {
      $(".mobile-dropdown").show();
      $(this).addClass("active");
    }
  });
  
  $(".list-item.dropdown a").click(function() {
    
    var $parent = $(this).parent();
    
    if($parent.hasClass("expanded")) {
      $parent.find(".list.msecondary").hide();
      $parent.removeClass("expanded");
      $parent.find("a span").html("+");
    } else {
      $parent.find(".list.msecondary").show();
      $parent.addClass("expanded");
      $parent.find("a span").html("-");
    }
  });
});

$(window).load(function() {
  $(".single-option-selector").change(function() {
    var color = $(this).val();
    
    $("#bigimage img").attr("src", $("img[data-color='" + color + "']").parent().attr("data-image"));
    $("#bigimage img").attr("data-zoom-image", $("img[data-color='" + color + "']").parent().attr("data-image"));
  });
});




  jQuery(document).on('click','.button-qty', function () {
    var $button = jQuery(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }

    $button.parent().find("input").val(newVal);
		
});
